const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const round2 = (value) => Math.round(toNumber(value) * 100) / 100;

const normalizeVatMode = (vatMode, taxAmount) => {
  const normalized = String(vatMode || '').trim().toLowerCase();

  if (['include', 'inclusive', 'vat_include'].includes(normalized)) {
    return 'include';
  }

  if (['exclude', 'exclusive', 'vat_exclude'].includes(normalized)) {
    return 'exclude';
  }

  if (['no_vat', 'novat', 'none', 'no-vat', 'non_vat'].includes(normalized)) {
    return 'no_vat';
  }

  return toNumber(taxAmount) > 0 ? 'exclude' : 'no_vat';
};

const getItemsGrossAmount = (items = []) =>
  round2(
    items.reduce((sum, item) => {
      const totalPrice = toNumber(item?.total_price);
      if (totalPrice > 0) {
        return sum + totalPrice;
      }

      return sum + toNumber(item?.quantity) * toNumber(item?.unit_price);
    }, 0)
  );

export const buildReceiptPdfSummary = (receipt = {}) => {
  const grossAmount = getItemsGrossAmount(receipt.items);
  const discountAmount = round2(receipt.discount);
  const taxRate = toNumber(receipt.tax_rate);
  const vatMode = normalizeVatMode(receipt.vat_mode, receipt.tax_amount);

  const grossAfterDiscount = round2(
    (grossAmount || 0) - discountAmount
  );

  let taxAmount = round2(receipt.tax_amount);
  let netAmount = 0;
  let grandTotal = round2(receipt.total_amount);

  if (vatMode === 'include') {
    const includeTotal = grandTotal || grossAfterDiscount;
    taxAmount = taxAmount || round2(includeTotal - includeTotal / (1 + taxRate / 100));
    grandTotal = includeTotal;
    netAmount = round2(grandTotal - taxAmount);
  } else if (vatMode === 'exclude') {
    netAmount = grossAfterDiscount;
    taxAmount = taxAmount || round2(netAmount * (taxRate / 100));
    grandTotal = grandTotal || round2(netAmount + taxAmount);
  } else {
    netAmount = grossAfterDiscount;
    taxAmount = 0;
    grandTotal = grandTotal || netAmount;
  }

  let grossBeforeDiscount = grossAmount;

  if (!grossBeforeDiscount) {
    if (vatMode === 'include') {
      grossBeforeDiscount = round2(grandTotal + discountAmount);
    } else {
      grossBeforeDiscount = round2(netAmount + discountAmount);
    }
  }

  return {
    vatMode,
    taxRate,
    grossAmount: round2(grossBeforeDiscount),
    discountAmount,
    netAmount: round2(netAmount),
    taxAmount: round2(taxAmount),
    grandTotal: round2(grandTotal)
  };
};
